import React, { Component } from 'react'
import classnames from 'classnames'
import { StickyContainer, StickyWrapper } from '@/common/sticky'
import Jockey from '@/utils/jockey'
import appInstall from '@/utils/appUtils/appInstall'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import { Modal, Tabs, Toast } from 'antd-mobile'
import { TabBarItem, CountDown, ProductList } from './components'
import { ProductItemContext } from './context'
import {
  // getMarkInfoListMock,
  getMarkInfoList,
  // getRemindOpenMock,
  // getRemindCloseMock,
  getRemindOpen,
  getRemindClose,
  // getRemindCloseMock,
  // refreshMarkInfoMock,
  refreshMarkInfo,
} from './apis'
import styles from './index.less'
import {
  MarkInfoItemType,
  SkuInfoItemType,
  StatusMap,
  TabItemType,
  VenueItemReqType,
  VenueItemResType,
} from './types'
import { EditConfigType } from '@/typings/types'
import {
  getCountDownSeconds,
  tabItemWidth,
  getSnapUpStatus,
  getCountDownTime,
  getTabListByMarkList,
  refreshGap,
  reqPolling,
  getRefreshTabListAndMarkInfoList,
  checkCurVenueIsEnd,
  checkCurVenueIsSaleout,
  changeTabItemStatus,
  changeSkuInfoNoticeFlag,
  checkActiveIsEnd,
  findNextStartTime,
  getInitStateParams,
} from './utils'
import { langMap, LangType } from './lang'
import { currencyCodeMap, currencySymbolMap } from '@/constant'
import { withReactTrack } from '@du/analytics-sdk'
import { createTrackConfig } from './trackConfig'

interface IProps {
  propsConfig?: {
    activityID: string
    tabBgColor: string
    tabBgColorActive: string
    tabTextColor: string
    tabTextColorActive: string
    tabBarInactiveTextColor: string
    tabBarActiveTextColor: string
    tabCount?: number
  }
  globalConfig: any
  editConfig: EditConfigType
}

interface IState {
  markInfoList: MarkInfoItemType[]
  activeIndex: number
  tabList: TabItemType[]
  countDownSeconds: number
}

@withReactTrack({ createTrackConfig })
class Seckill extends Component<IProps, IState> {
  static config = {
    name: 'poizon-activity-spike',
  }

  constructor(props: IProps) {
    super(props)
    this.state = {
      markInfoList: [],
      activeIndex: 0,
      tabList: [],
      countDownSeconds: 0,
    }
    if (props?.editConfig?.lang) {
      this.lang = langMap[props.editConfig.lang] || langMap.en
    } else {
      this.lang = langMap.en
    }
    this.translateX = 0
    this.pushOpenStatus = 1
    this.refreshCancel = null
    this.openCb = null
    this.listLoading = false
    this.isSaleOutToast = false
  }

  lang: LangType
  translateX: number
  pushOpenStatus: 0 | 1
  // testNumber: number;
  refreshCancel: any
  openCb: any
  listLoading: boolean
  isSaleOutToast: boolean
  componentDidMount() {
    // 获取列表
    this.getMarkInfoList()
    this.checkAppVersion()

    // 推送订阅
    Jockey.getNotificationState(this.onNotificationChange)
    // 页面刷新监听
    Jockey.refreshHybridData(this.refreshPageData)
  }

  componentWillUnmount() {
    this.cancelRefresh()
    this.openCb = null
  }

  refreshPageData = () => {
    // 发起主会场请求
    // 目前主要是提醒状态刷新
    const { lang, local } = this.props?.editConfig
    const _this = this
    // getMarkInfoListMock({
    getMarkInfoList({
      language: lang,
      countryCode: local,
      currencyCode: currencyCodeMap[local],
    }).then((res) => {
      const { activeIndex, markInfoList, tabList } = _this.state
      const curTabData = tabList[activeIndex]
      // 如果是即将开始
      if (curTabData && curTabData.status === StatusMap.aboutOf) {
        // TODO
        const nestItemData = res.data.markInfoList.find((ele) => ele.venueId == curTabData.venueId)
        if (nestItemData) {
          _this.setState({
            markInfoList: markInfoList.map((ele) => {
              if (ele.venueId === nestItemData.venueId) {
                return nestItemData
              }
              return ele
            }),
          })
        }
      }
    })
  }

  checkAppVersion = () => {
    const appVersion = getAppVersion()
    if (isDuApp() && compareVersion(appVersion, '2.3.6') === -1) {
      Modal.alert('', <div style={{ width: 300 }}>{this.lang.appVersionUpdateMsg}</div>, [
        { text: this.lang.appVersionUpdateCancelText, onPress: () => console.log('cancel') },
        { text: this.lang.appVersionUpdateOkText, onPress: () => console.log('ok') },
      ])
    }
  }

  cancelRefresh = () => {
    if (typeof this.refreshCancel === 'function') {
      this.refreshCancel()
    }
  }

  onNotificationChange = (status: 0 | 1) => {
    if (status === 1 && this.pushOpenStatus === 0) {
      if (this.openCb && typeof this.openCb === 'function') {
        this.openCb()
      }
    }
    this.pushOpenStatus = status
  }

  // TODO 代码精简
  // 本场已售罄
  refreshSkuInfoList = (index?: number) => {
    const _this = this
    this.cancelRefresh()
    const usedIndex = index !== undefined ? index : this.state.activeIndex
    const curItem = this.state.tabList[usedIndex]
    const curItemData = this.state.markInfoList[usedIndex]
    if (!curItem || !curItemData) {
      return
    }
    // 如果是正在进行中的才进行轮询
    if (curItem.status !== StatusMap.ing) {
      return
    }
    const { lang, local } = this.props?.editConfig
    const initParams: VenueItemReqType = {
      language: lang,
      countryCode: local,
      currencyCode: currencyCodeMap[local],
      venueId: curItemData.venueId,
      // venueId: 23,
    }
    const { cancel } = reqPolling({
      // apiFn: refreshMarkInfoMock,
      errorMsg: _this.lang.errorMsg,
      apiFn: refreshMarkInfo,
      cb(res: VenueItemResType) {
        const { tabList, markInfoList } = _this.state
        if (res.code === 200 && res?.data?.venueSkuInfoList.length !== 0) {
          // 再刷新的过程中 只关心库存
          const isEnd = res.data.stockFlag === 2
          const isSaleout = checkCurVenueIsSaleout(res.data)
          if (!isEnd) {
            if (isSaleout) {
              // 售罄
              // 上次提示之后就不提示
              if (!_this.isSaleOutToast) {
                const time = findNextStartTime(usedIndex, tabList)
                Toast.info(_this.lang.getCurSaleOut(time))
                _this.isSaleOutToast = true
              }
            } else {
              _this.isSaleOutToast = false
            }
            _this.setState(
              getRefreshTabListAndMarkInfoList({
                markInfoItem: res.data,
                tabList,
                index: usedIndex,
                markInfoList,
              })
            )
            return {
              isGoOn: true,
              // 目前 params 应该是一样的
              params: initParams,
            }
          } else {
            // 前端定时器与服务端时间可能有时延
            _this.getMarkInfoListDelay()
            // 提示 // 结束
            const time = findNextStartTime(usedIndex, tabList)
            Toast.info(_this.lang.getCurActiveOver(time))
          }
        }
        return { isGoOn: false }
      },
      time: refreshGap,
      initParams,
    })
    if (this.refreshCancel === 'function') {
      this.refreshCancel()
    }
    this.refreshCancel = cancel
  }

  onRemindStatusChange = (info: SkuInfoItemType, isOpen: boolean) => {
    if (!isDuApp()) {
      this.handleAppInstall()
      return
    }
    const req = isOpen ? getRemindOpen : getRemindClose
    const { lang, local } = this.props?.editConfig
    const { activeIndex, markInfoList } = this.state
    const markInfoItem = markInfoList[activeIndex]
    const _this = this
    if (isOpen && _this.pushOpenStatus === 0) {
      Modal.alert('', <div style={{ width: 300 }}>{this.lang.sysOpenMsg}</div>, [
        { text: this.lang.sysOpenCancelText, onPress: () => console.log('cancel') },
        {
          text: this.lang.sysOpenOkText,
          onPress: () => {
            _this.openCb = () => {
              req({
                language: lang,
                countryCode: local,
                currencyCode: currencyCodeMap[local],
                venueId: markInfoItem.venueId,
                skuId: info.skuId,
              })
                .then(() => {
                  _this.setState({
                    markInfoList: changeSkuInfoNoticeFlag(
                      markInfoList,
                      markInfoItem.venueId,
                      info.skuId
                    ),
                  })
                })
                .then(() => {
                  Toast.info(_this.lang.remindOpen)
                })
            }
            Jockey.enableNativePush()
          },
        },
      ])
      return
    }
    // 未开启消息 不发
    req({
      language: lang,
      countryCode: local,
      currencyCode: currencyCodeMap[local],
      venueId: markInfoItem.venueId,
      skuId: info.skuId,
    })
      .then((res) => {
        if (res.code === 200) {
          if (!isOpen) {
            Toast.info(this.lang.remindClose)
          } else if (isOpen && _this.pushOpenStatus === 1) {
            Toast.info(_this.lang.remindOpen)
          }
          _this.setState({
            markInfoList: changeSkuInfoNoticeFlag(markInfoList, markInfoItem.venueId, info.skuId),
          })
        }
      })
      .catch((res) => {
        if (typeof res.msg === 'string') {
          Toast.info(res.msg)
        }
      })
  }

  onProductItemClick = (info: SkuInfoItemType) => {
    this.onGoBuy(info)
  }

  handleAppInstall = () => {
    appInstall('/web/browser', {
      url: location.href,
    })
  }

  checkActiveIsOverHandler = async (markInfo: MarkInfoItemType) => {
    const { lang, local } = this.props?.editConfig
    const _this = this
    try {
      const res = await refreshMarkInfo({
        language: lang,
        countryCode: local,
        currencyCode: currencyCodeMap[local],
        venueId: markInfo.venueId,
      })
      const isOver = checkCurVenueIsEnd(res.data)
      if (isOver === true) {
        // 提示本场活动已结束
        const { tabList, activeIndex } = _this.state
        const time = findNextStartTime(activeIndex, tabList)
        Toast.info(_this.lang.getCurActiveOver(time))
        _this.getMarkInfoListDelay()
      }
      return isOver
    } catch (error) {
      console.error(error)
    }
    return false
  }

  onGoBuy = async (info: SkuInfoItemType) => {
    if (!isDuApp()) {
      this.handleAppInstall()
      return
    }
    // 点击请求判断当前场次是否结束

    const { activeIndex, markInfoList } = this.state
    const markInfo = markInfoList[activeIndex]
    // 这是一种临界情况 与服务端确认活动是否结束
    const isOver = await this.checkActiveIsOverHandler(markInfo)
    if (isOver) {
      return
    }
    const params = {
      venueId: markInfo.venueId || '',
      spuId: info.spuId,
      skuId: info.skuId,
      biddingNo: info.biddingNo || '',
    }
    if (isDuApp()) {
      Jockey.openNativePage('/sell/productSecKillDetail', params)
      return
    }

    appInstall('/sell/productSecKillDetail', params)
    // 去商详页
  }

  // 通知
  getMarkInfoList = () => {
    const { lang, local } = this.props?.editConfig
    const _this = this
    if (this.listLoading === true) {
      return
    }
    this.listLoading = true
    // getMarkInfoListMock({
    getMarkInfoList({
      language: lang,
      countryCode: local,
      currencyCode: currencyCodeMap[local],
      // venueId: 1,
      // timeZone: 's',
    })
      .then((res) => {
        this.listLoading = false
        console.log('res.data===', res.data)
        const { markInfoList } = res.data
        // 最后一场信息
        if (checkActiveIsEnd(markInfoList)) {
          // 如果会场信息已结束
          Toast.info(this.lang.activeOverMsg)
          // 如果原来还剩一场会场 把它状态改为 结束
          // TODO
          this.setState({
            countDownSeconds: 0,
            activeIndex: 0,
            ...getInitStateParams(_this.state.markInfoList, _this.state.tabList, markInfoList),
            // tabList: markInfoList.length
            //   ? getTabListByMarkList(markInfoList)
            //   : _this.state.tabList.map((ele) => ({ ...ele, status: StatusMap.end })),
            // markInfoList,
          })
          return
        }
        const activeIndex = 0
        const tabList: TabItemType[] = getTabListByMarkList(markInfoList)
        const countDownTime = getCountDownTime(
          tabList[activeIndex].status,
          markInfoList[0].begTime,
          markInfoList[0].endTime
        )
        const countDownSeconds = getCountDownSeconds(countDownTime, tabList[activeIndex].status)
        this.setState(
          {
            markInfoList,
            tabList,
            activeIndex: 0,
            countDownSeconds,
          },
          () => {
            // 查询到主会场之后五秒后刷新
            setTimeout(() => {
              _this.refreshSkuInfoList()
            }, refreshGap)
          }
        )
      })
      .catch((e) => {
        this.listLoading = false
        console.error(e, 'e....e')
      })
  }

  getMarkInfoListDelay = () => {
    const _this = this
    _this.cancelRefresh()
    setTimeout(() => {
      _this.getMarkInfoList()
    }, 1500)
  }

  onTimeEnd = () => {
    // 本场结束 提示活动已结束结束
    const { activeIndex, markInfoList, tabList } = this.state
    const curData = markInfoList[activeIndex]
    const isEnd = checkCurVenueIsEnd(curData)

    // 不是最后一场
    if (isEnd && markInfoList.length > 1) {
      const time = findNextStartTime(activeIndex, tabList)
      Toast.info(this.lang.getCurActiveOver(time))
    }
    //
    this.getMarkInfoListDelay()
  }

  renderContent = () => <div />

  // 切换tab 已经结束的场次 要清空
  handleTabChange = (params: any) => {
    this.$track('poizon_common_click', {
      current_page: 82,
      block_type: 3026,
      button_title: params.venueId,
    })
    const { index } = params
    // 已售罄状态置空
    this.isSaleOutToast = false
    this.cancelRefresh()
    this.refreshSkuInfoList(index)
    this.setState(({ markInfoList, tabList }) => {
      const curTabData = markInfoList[index]
      const tabItem = tabList[index]
      return {
        activeIndex: index,
        countDownSeconds: getCountDownSeconds(
          tabItem.status === StatusMap.aboutOf ? curTabData.begTime : curTabData.endTime,
          tabItem.status
        ),
      }
    })
  }

  observeList = () => {
    const boxList = [...document.querySelectorAll('.aaaaa')]
    console.log('.....boxList', boxList)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((item) => {
          // intersectionRatio === 1说明该元素完全暴露出来，符合业务需求
          // console.log(
          //   '........item',
          //   item.target.attributes.getNamedItem('notice-flag').value,
          //   item.target.attributes.getNamedItem('spu-id').value
          // )
          // if (item.intersectionRatio >= 0.5) {
          //   // 。。。 埋点曝光代码
          //   io.unobserve(item.target)
          // }
        })
      },
      {
        root: null,
        threshold: [0.5], // 阀值设为1，当只有比例达到1时才触发回调函数
      }
    )
    // observe遍历监听所有box节点
    boxList.forEach((box) => io.observe(box))
  }

  renderTab = (props: any) => {
    return (
      <TabBarItem
        snapUpStatus={this.lang.snapUpStatus}
        // editConfig={this.props.editConfig}
        data={props}
      />
    )
  }

  renderSticky = (props: any, { style }: any) => {
    // const propsConfig = defaultProps;
    const { propsConfig } = this.props
    if (!propsConfig) {
      return null
    }

    const { tabCount, tabBgColor } = propsConfig
    const { countDownSeconds, activeIndex, markInfoList, tabList } = this.state
    const curTabItem = markInfoList[activeIndex]
    const curTab = tabList[activeIndex]
    return (
      <div className="module-venue-tab-default-bar" style={{ ...style, zIndex: 1 }}>
        {!!tabList.length && (
          <Tabs.DefaultTabBar
            {...props}
            renderTab={this.renderTab}
            page={tabCount}
            className="aaaaa"
          />
        )}
        <CountDown
          onTimeEnd={this.onTimeEnd}
          seconds={countDownSeconds}
          endMsg={curTab?.status === StatusMap.aboutOf ? this.lang.start : this.lang.end}
          data={curTabItem}
          tabBgColor={tabBgColor}
        />
      </div>
    )
  }

  renderTabBar = (props: any) => (
    <StickyWrapper>
      {(sProps: any) => {
        return this.renderSticky(props, sProps)
      }}
    </StickyWrapper>
  )

  render() {
    const { propsConfig, globalConfig } = this.props
    const { editConfig } = this.props
    if (!propsConfig) {
      return <div>请添加属性</div>
    }
    const { tabBgColor, tabBgColorActive, tabTextColorActive, tabTextColor } = propsConfig
    const moneySymbol = currencySymbolMap[editConfig.local] || 'HK$'
    const btnStatusMap = this.lang.btnStatus
    const { activeIndex, tabList, markInfoList } = this.state
    const curTabItem = markInfoList[activeIndex]
    const curTab = tabList[activeIndex]
    return (
      <div
        className={classnames({
          [styles['seckill-container']]: true,
          'seckill-container': true,
        })}
      >
        <ProductItemContext.Provider
          value={{
            moneySymbol,
            btnStatusMap,
            pageTitle: globalConfig?.title,
            tabItem: curTab,
            onRemindStatusChange: this.onRemindStatusChange,
            onGoBuy: this.onGoBuy,
            onProductItemClick: this.onProductItemClick,
            getRemainingNumber: this.lang.getRemainingNumber,
            getTotalNumber: this.lang.getTotalNumber,
            local: editConfig.local,
          }}
        >
          <StickyContainer>
            {!!tabList.length && (
              <Tabs
                page={activeIndex}
                tabs={tabList}
                onChange={this.handleTabChange}
                tabBarBackgroundColor={tabBgColor}
                tabBarActiveTextColor={tabTextColor}
                tabBarInactiveTextColor={tabTextColorActive}
                tabBarUnderlineStyle={{ opacity: 0, display: 'none' }}
                // tabBarUnderlineStyle={{
                //   opacity: 0,
                //   display: 'none',
                //   height: 0,
                //   background: tabBgColorActive,
                // }}
                renderTabBar={this.renderTabBar}
              >
                {this.renderContent}
              </Tabs>
            )}
            {!!curTabItem && (
              <ProductList
                key={`${activeIndex}-${curTabItem.venueId}-${curTabItem?.venueSkuInfoList?.length}`}
                dataSource={curTabItem.venueSkuInfoList}
              />
            )}
          </StickyContainer>
        </ProductItemContext.Provider>
        <style>
          {`
            .seckill-container .am-tabs-default-bar-tab-active {
              background: ${tabBgColorActive || 'rgb(43, 43, 43)'};
            }
          `}
        </style>
      </div>
    )
  }
}

export default Seckill
